import { render } from "./ClientInvoiceBuyerModal.vue?vue&type=template&id=dc5420e2&scoped=true"
import script from "./ClientInvoiceBuyerModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientInvoiceBuyerModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientInvoiceBuyerModal.vue?vue&type=style&index=0&id=dc5420e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5420e2"]])

export default __exports__